import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts"
import "./style/EquityChart.scss"

// 📊 Dummy data for now
const data = [
  { date: "Mon", balance: 0 },
  { date: "Tue", balance: 0 },
  { date: "Wed", balance: 0 },
  { date: "Thu", balance: 0 },
  { date: "Fri", balance: 0 },
  { date: "Sat", balance: 0 },
  { date: "Sun", balance: 0 }
]

const EquityChart = () => {
  return (
    <div className="equity-chart">
      <h3>Portfolio Equity</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <XAxis dataKey="date" stroke="#94a3b8" />
          <YAxis stroke="#94a3b8" />
          <Tooltip />
          <Line type="monotone" dataKey="balance" stroke="#3b82f6" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default EquityChart
